import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import TickettypesList from './TickettypesList/TickettypesList';
import TickettypeEdit from './TickettypeEdit/TickettypeEdit';
import TickettypeCreate from './TickettypeCreate/TickettypeCreate';
import TickettypeDelete from './TickettypeDelete/TickettypeDelete';

const Tickettypes = ({ match }) => {
    return (
        <div className="Tickettypes">
            <ContainerWrapper container="tickettypes">
                <Route exact path={ match.path } component={TickettypesList} />
                <Route exact path={ `${ match.url }/new` } component={TickettypeCreate} />
                <Route exact path={ `${ match.url }/edit/:tickettypeId` } component={TickettypeEdit} />
                <Route exact path={ `${ match.url }/delete/:tickettypeId` } component={TickettypeDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Tickettypes;
